export const expenseItems = {
  title: 'Expense items',
  titles: {
    create: 'Add expense item',
    edit: 'Edit expense item',
    detail: 'Expense item detail',
    list: 'Expense item catalog',
    addQuick: 'Quick add',
  },
  sections: {
    basic: 'Basic information',
  },
  fields: {
    code: 'Item code',
    name: 'Expense item',
    templateContent: 'Template content',
    defaultCurrency: 'Default currency',
    sortOrder: 'Sort order',
    status: 'Status',
    onOffAction: 'On / off',
    actions: 'Actions',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
  messages: {
    noData: 'No data',
  },
  filter: {
    placeholder: 'Search by code or item name...',
  },
}
